"use strict";var n=require("../../Constant/UnknownVersion.cjs");exports.extractVersion=function(r,t){return void 0===t&&(t=1),r?r[t]:n.UNKNOWN_VERSION};
//# sourceMappingURL=extractVersion.cjs.map
